import UserApi from '../../apis/userApi'
import { CLEAR_USER_STATE, GET_ALL_USER, GET_DETAIL_USER } from '../actionTypes'

export const getDetailUser = (data) => {
  return {
    type: GET_DETAIL_USER,
    payload: data,
  }
}

export const getAllUser = (data) => {
  return {
    type: GET_ALL_USER,
    payload: data,
  }
}

export const clearUserState = () => {
  return {
    type: CLEAR_USER_STATE,
  }
}

export const fetchDetailUser = () => {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      UserApi.getDetailUser()
        .then((response) => {
          resolve(response)
          dispatch(getDetailUser(response.data.data))
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export const fetchAllUser = () => {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      UserApi.getAllUser()
        .then((response) => {
          resolve(response)
          dispatch(getAllUser(response.data.data))
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export const updateProfileUser = (id, data) => {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      UserApi.updateProfile(id, data)
        .then((response) => {
          resolve(response)
          dispatch(fetchDetailUser())
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
